import { render } from "./UserForgotPassword.vue?vue&type=template&id=402f36ec&scoped=true"
import script from "./UserForgotPassword.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./UserForgotPassword.vue?vue&type=script&charset=utf-8&lang=js"

import "./UserForgotPassword.vue?vue&type=style&index=0&id=402f36ec&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-402f36ec"]])

export default __exports__